<!--
  //app/components/Shared/icons/DropDownIcon.vue
  -->

<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
};

withDefaults(defineProps<Props>(), {
  height: 14,
  width: 14,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 10 6"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="m1 1 4 4 4-4"
    />
  </svg>
</template>

<style scoped></style>
